// import { oc }                           from "ts-optchain";
// import { ErrorLogService }              from "@/services/";
import { formatDateTime, stringHelper, themeHelper }   from "@/components/mixins";
import Vue                                from "vue";
import { mapGetters }                     from "vuex";


export default Vue.extend({
    name: "CartHeader",
    components: {},
    mixins: [formatDateTime, stringHelper, themeHelper],

    created() {
        return
    },
    computed: {
        ...mapGetters([
            "user",
            "getContentItem",
        ]),
        LogoImage () {
            const image = this.getImage("logoBlue")
            return image
        },
    },
    data: () => ({
    }),
    methods: {

    },
    watch: {
    },
});
